<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.orderCancelPendingDeals'), $t('text.list')]"
      ></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        id="receivesTable"
        row-id="id"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="orderSerialNo"
          :title="$t('order.serialNo')"
          min-width="200"
        >
          <template v-slot="{ row }">
            <div
              class="float-left mgr5 blue"
              id="copyText"
              @click="showOrder(row)"
            >
              {{ row.orderSerialNo }}
            </div>
            <div
              class="copy-btn"
              v-if="row.orderSerialNo != null"
              @click="copy"
              data-clipboard-action="copy"
              :data-clipboard-text="row.orderSerialNo"
            >
              复制
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="dealType"
          :title="$t('order.dealType')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span v-if="row.dealType !== null">
              {{ $t("dealTypes." + row.dealType) }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="content"
          :title="$t('event.content')"
          min-width="400"
        >
          <template v-slot="{ row }">
            {{ row.content }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="handleAt1"
          :title="$t('text.workflowState')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span v-if="row.handleAt == null" class="red">
              {{ $t("eventStates.unHandle") }}
            </span>
            <span v-else>{{ $t("eventStates.handled") }}</span>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="handleAt"
          :title="$t('event.handleAt')"
          min-width="110"
        />
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          min-width="110"
        />
        <vxe-table-column field="action" :title="$t('text.action')" width="80">
          <template v-slot="{ row, rowIndex }">
            <el-button
              v-if="row.handleAt == null"
              type="text"
              size="mini"
              @click="handle(row, rowIndex)"
              >{{ $t("action.dealed") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <drawer
      :title="$t('text.view', [$t('menu.bargains')])"
      :visible.sync="showOrderDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-order
        source="orderCancelPendingDeals"
        :uuid="currentRowOrderUuid"
      />
    </drawer>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils";
import ShowOrder from "@/views/oms/bargains/showOrder.vue";

import Event from "@/api/event.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: { Clipboard, ShowOrder },

  data() {
    return {
      Util: Util,
      sorter: {
        sortBy: "events_id",
        sortIndicator: "desc",
      },
      narrows: [
        [
          {
            label: this.$t("text.workflowState"),
            items: [
              {
                label: this.$t("eventStates.handled"),
                key: "yes",
                condition: { handle: "yes" },
              },
              {
                label: this.$t("eventStates.unHandle"),
                key: "no",
                condition: { handle: "no" },
              },
            ],
          },
        ],
      ],
      initFilter: "no",
      //
      currentRowOrderUuid: null,
      showOrderDF: false,
    };
  },

  created() {
    const self = this;
  },
  methods: {
    //=========
    showOrder(row) {
      this.currentRowOrderUuid = row.orderUuid;
      this.showOrderDF = true;
    },
    copy() {
      const self = this;
      let cpd = new Clipboard(".copy-btn");
      cpd.on("success", function () {
        // console.log("=======");
        // self.$message({
        //   message: "复制成功",
        //   type: "success",
        //   duration: 100,
        // });
        // alert("复制成功");
      });
      self.$message({
        message: "复制成功",
        type: "success",
        duration: 1000,
      });
    },
    handle(row, rowIndex) {
      const self = this;
      Event.handle(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.dealSuccess"),
            type: "success",
          });
          self.records[rowIndex].handleAt = Util.formatDate(new Date());
        } else {
          self.sysError();
        }
      });
    },
    dataProvider(params) {
      return Event.search(params);
    },
  },
};
</script>
<style scoped>
.copy-btn {
  float: left;
  border: 1px solid #dcdfe6;
  color: #606266;
  font-size: 8px;
  height: 22px;
  line-height: 22px;
  border-radius: 2px;
  padding: 0 2px;
  cursor: pointer;
}
</style>
